import type { AuthoredEntityOrSingleSchema } from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function ensureSchemaFields(schema: AuthoredEntityOrSingleSchema): SchemaField[] {
  if (!Array.isArray(schema.fields)) {
    schema.fields = []
  }
  return schema.fields
}
